import { useProgress } from "@react-three/drei";
import { useRef } from "react";
import { gsap } from "gsap";
import { useGSAP } from "@gsap/react";
import { observer } from "mobx-react";

export const LoadingScreen = () => {
  const { progress, loaded } = useProgress();
  gsap.registerPlugin(useGSAP);

  const container = useRef<HTMLDivElement>(null);
  let initialRender = true
  useGSAP(
    () => {
      if (initialRender) {
        gsap.to("body", {
          overflow: "hidden",
        });

        gsap.to("#coin", {
          scale: 1.2,
          duration: 1.8,
          repeat: -1,
        });
        initialRender = false;
      }

      if (loaded) {
        gsap
          .timeline()
          .to(
            "#loading",
            {
              x: -3000,
              duration: 4,
            },
            1
          )
          .to(
            "#progress",
            {
              x: 3000,
              duration: 4,
            },
            1
          )
          .to(
            "#coin",
            {
              scale: 600,
              duration: 5,
            },
            1.5
          )
          .to(
            "#container",
            {
              opacity: 0,
              display: "none",
            },
            2
          )
          .to(
            "body",
            {
              overflow: "visible",
            },
            2
          );
      }
    },
    { dependencies: [loaded, initialRender], revertOnUpdate: true }
  ); // <-- scope is for selector text (optional)

  return (
    <div
      id="container"
      ref={container}
      className="fixed w-full h-full top-0 left-0 bg-black  z-[99999] gap-3 text-white flex flex-col justify-center items-center "
    >
      <img
        className=""
        id="coin"
        src="/assets/images/logo.png"
        width={128}
        height={128}
        alt=""
      />

      <p id="loading" className=" text-5xl font-semibold animate-pulse">
        LOADING
      </p>
      <p id="progress" className="text-5xl">
        {progress && progress.toFixed(0)}%
      </p>
    </div>
  );
};

export default observer(LoadingScreen);
